{
    "tr": {
        "Yes": "Evet",
        "No": "Hayır",
        "Cancel": "İptal",
        "Close": "Kapat",
        "Clear": "Temizle",
        "Done": "Tamam",
        "Loading": "Yükleniyor...",
        "Select": "Seç...",
        "Search": "Ara",
        "Back": "Geri",
        "OK": "Tamam",

        "dxCollectionWidget-noDataText": "Gösterilecek bilgi yok",

        "dxDropDownEditor-selectLabel": "Select",

        "validation-required": "Zorunlu",
        "validation-required-formatted": "{0} gerekli",
        "validation-numeric": "Değer bir sayı olmalı",
        "validation-numeric-formatted": "{0} bir sayı olmalı",
        "validation-range": "Değer aralık dışında",
        "validation-range-formatted": "{0} aralık dışında",
        "validation-stringLength": "Değerin uzunluğu doğru değil",
        "validation-stringLength-formatted": "{0} uzunluğu doğru değil",
        "validation-custom": "Değer geçersiz",
        "validation-custom-formatted": "{0} geçersiz",
        "validation-async": "Value is invalid",
        "validation-async-formatted": "{0} is invalid",
        "validation-compare": "Değerler eşleşmiyor",
        "validation-compare-formatted": "{0} eşleşmiyor",
        "validation-pattern": "Değer kalıpla eşleşmiyor",
        "validation-pattern-formatted": "{0} kalıpla eşleşmiyor",
        "validation-email": "E-posta geçersiz",
        "validation-email-formatted": "{0} geçersiz",
        "validation-mask": "Değer geçersiz",

        "dxLookup-searchPlaceholder": "Minimum karakter sayısı: {0}",

        "dxList-pullingDownText": "Yenilemek için aşağıya çekin...",
        "dxList-pulledDownText": "Yenilemek için bırakın...",
        "dxList-refreshingText": "Yenileniyor...",
        "dxList-pageLoadingText": "Yükleniyor...",
        "dxList-nextButtonText": "Daha",
        "dxList-selectAll": "Tümünü Seç",
        "dxListEditDecorator-delete": "Sil",
        "dxListEditDecorator-more": "Daha",

        "dxScrollView-pullingDownText": "Yenilemek için aşağıya çekin...",
        "dxScrollView-pulledDownText": "Yenilemek için bırakın...",
        "dxScrollView-refreshingText": "Yenileniyor...",
        "dxScrollView-reachBottomText": "Yükleniyor...",

        "dxDateBox-simulatedDataPickerTitleTime": "Saat seç",
        "dxDateBox-simulatedDataPickerTitleDate": "Tarih seç",
        "dxDateBox-simulatedDataPickerTitleDateTime": "Tarih ve saati seçin",
        "dxDateBox-validation-datetime": "Değer bir tarih veya saat olmalıdır",

        "dxDateRangeBox-invalidStartDateMessage": "Start value must be a date",
        "dxDateRangeBox-invalidEndDateMessage": "End value must be a date",
        "dxDateRangeBox-startDateOutOfRangeMessage": "Start date is out of range",
        "dxDateRangeBox-endDateOutOfRangeMessage": "End date is out of range",
        "dxDateRangeBox-startDateLabel": "Başlangıç Tarihi",
        "dxDateRangeBox-endDateLabel": "Bitiş Tarihi",

        "dxFileUploader-selectFile": "Dosya seç",
        "dxFileUploader-dropFile": "veya Dosyayı buraya bırakın",
        "dxFileUploader-bytes": "bytes",
        "dxFileUploader-kb": "KB",
        "dxFileUploader-Mb": "MB",
        "dxFileUploader-Gb": "GB",
        "dxFileUploader-upload": "Yükleme",
        "dxFileUploader-uploaded": "Yüklenen",
        "dxFileUploader-readyToUpload": "Yüklemeye hazır",
        "dxFileUploader-uploadAbortedMessage": "Upload cancelled",
        "dxFileUploader-uploadFailedMessage": "Yükleme başarısız",
        "dxFileUploader-invalidFileExtension": "Dosya türüne izin verilmiyor",
        "dxFileUploader-invalidMaxFileSize": "Dosya çok büyük",
        "dxFileUploader-invalidMinFileSize": "Dosya çok küçük",

        "dxRangeSlider-ariaFrom": "İtibaren",
        "dxRangeSlider-ariaTill": "Kadar",
        "dxSwitch-switchedOnText": "Açık",
        "dxSwitch-switchedOffText": "Kapalı",

        "dxForm-optionalMark": "isteğe bağlı",
        "dxForm-requiredMessage": "{0} gerekli",

        "dxNumberBox-invalidValueMessage": "Değer bir sayı olmalı",
        "dxNumberBox-noDataText": "Veri yok",

        "dxDataGrid-emptyHeaderWithColumnChooserText": "Use {0} to display columns",
        "dxDataGrid-emptyHeaderWithGroupPanelText": "Drag a column from the group panel here",
        "dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText": "Use {0} or drag a column from the group panel",
        "dxDataGrid-emptyHeaderColumnChooserText": "column chooser",
        "dxDataGrid-columnChooserTitle": "Sütun Seçici",
        "dxDataGrid-columnChooserEmptyText": "Sütunu gizlemek için buraya sürükleyin",
        "dxDataGrid-groupContinuesMessage": "Bir sonraki sayfada devam ediyor",
        "dxDataGrid-groupContinuedMessage": "Önceki sayfadan devam",
        "dxDataGrid-groupHeaderText": "Bu Sütuna Göre Grupla",
        "dxDataGrid-ungroupHeaderText": "Grubu Kaldır",
        "dxDataGrid-ungroupAllText": "Tüm Grupları Kaldır",
        "dxDataGrid-editingEditRow": "Düzenle",
        "dxDataGrid-editingSaveRowChanges": "Kaydet",
        "dxDataGrid-editingCancelRowChanges": "İptal",
        "dxDataGrid-editingDeleteRow": "Sil",
        "dxDataGrid-editingUndeleteRow": "Silme",
        "dxDataGrid-editingConfirmDeleteMessage": "Bu kaydı silmek istediğinize emin misiniz?",
        "dxDataGrid-validationCancelChanges": "Değişiklikleri iptal et",
        "dxDataGrid-groupPanelEmptyText": "Bu sütuna göre gruplamak için bir sütun başlığını buraya sürükleyin",
        "dxDataGrid-noDataText": "Veri yok",
        "dxDataGrid-searchPanelPlaceholder": "Arama...",
        "dxDataGrid-filterRowShowAllText": "(Tümü)",
        "dxDataGrid-filterRowResetOperationText": "Sıfırla",
        "dxDataGrid-filterRowOperationEquals": "Eşittir",
        "dxDataGrid-filterRowOperationNotEquals": "Eşit değil",
        "dxDataGrid-filterRowOperationLess": "Daha küçük",
        "dxDataGrid-filterRowOperationLessOrEquals": "Daha küçük veya eşit",
        "dxDataGrid-filterRowOperationGreater": "Daha büyük",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "Daha büyük veya eşit",
        "dxDataGrid-filterRowOperationStartsWith": "İle başlar",
        "dxDataGrid-filterRowOperationContains": "İçeren",
        "dxDataGrid-filterRowOperationNotContains": "İçermeyen",
        "dxDataGrid-filterRowOperationEndsWith": "İle biten",
        "dxDataGrid-filterRowOperationBetween": "Arasında",
        "dxDataGrid-filterRowOperationBetweenStartText": "Başla",
        "dxDataGrid-filterRowOperationBetweenEndText": "Bitiş",
        "dxDataGrid-ariaSearchBox": "Search box",
        "dxDataGrid-applyFilterText": "Filtre uygula",
        "dxDataGrid-trueText": "evet",
        "dxDataGrid-falseText": "hayır",
        "dxDataGrid-sortingAscendingText": "Artan Sıralama",
        "dxDataGrid-sortingDescendingText": "Azalan Sıralama",
        "dxDataGrid-sortingClearText": "Sıralamayı Temizle",
        "dxDataGrid-ariaNotSortedColumn": "Not sorted column",
        "dxDataGrid-ariaSortedAscendingColumn": "Column sorted in ascending order",
        "dxDataGrid-ariaSortedDescendingColumn": "Column sorted in descending order",
        "dxDataGrid-ariaSortIndex": "Sort index {0}",
        "dxDataGrid-editingSaveAllChanges": "Değişiklikleri Kaydet",
        "dxDataGrid-editingCancelAllChanges": "Değişiklikleri iptal et",
        "dxDataGrid-editingAddRow": "Satır ekle",
        "dxDataGrid-summaryMin": "Min: {0}",
        "dxDataGrid-summaryMinOtherColumn": "{1} min: {0}",
        "dxDataGrid-summaryMax": "Max: {0}",
        "dxDataGrid-summaryMaxOtherColumn": "{1} max: {0}",
        "dxDataGrid-summaryAvg": "Ort: {0}",
        "dxDataGrid-summaryAvgOtherColumn": "{1} ortalaması: {0}",
        "dxDataGrid-summarySum": "Top: {0}",
        "dxDataGrid-summarySumOtherColumn": "{1} toplamı: {0}",
        "dxDataGrid-summaryCount": "Toplam: {0}",
        "dxDataGrid-columnFixingFix": "Sabitle",
        "dxDataGrid-columnFixingUnfix": "Çöz",
        "dxDataGrid-columnFixingLeftPosition": "Sola",
        "dxDataGrid-columnFixingRightPosition": "Sağa",
        "dxDataGrid-exportTo": "Dışa aktar",
        "dxDataGrid-exportToExcel": "Excel dosyasına aktar",
        "dxDataGrid-exporting": "Dışa Aktar...",
        "dxDataGrid-excelFormat": "Excel dosyası",
        "dxDataGrid-selectedRows": "Seçili satırlar",
        "dxDataGrid-exportSelectedRows": "Seçili satırları aktar",
        "dxDataGrid-exportAll": "Tüm verileri dışa aktar",
        "dxDataGrid-headerFilterLabel": "Filter options",
        "dxDataGrid-headerFilterIndicatorLabel": "Show filter options for column '{0}'",
        "dxDataGrid-headerFilterEmptyValue": "(Blanks)",
        "dxDataGrid-headerFilterOK": "Tamam",
        "dxDataGrid-headerFilterCancel": "İptal",
        "dxDataGrid-ariaAdaptiveCollapse": "Hide additional data",
        "dxDataGrid-ariaAdaptiveExpand": "Display additional data",
        "dxDataGrid-ariaColumn": "Sütun",
        "dxDataGrid-ariaColumnHeader": "Column header",
        "dxDataGrid-ariaValue": "Veri",
        "dxDataGrid-ariaError": "Error",
        "dxDataGrid-ariaRevertButton": "Press Escape to discard the changes",
        "dxDataGrid-ariaFilterCell": "Filtre hücresi",
        "dxDataGrid-ariaCollapse": "Daralt",
        "dxDataGrid-ariaModifiedCell": "Modified",
        "dxDataGrid-ariaDeletedCell": "Deleted",
        "dxDataGrid-ariaEditableCell": "Editable",
        "dxDataGrid-ariaExpand": "Genişlet",
        "dxDataGrid-ariaCollapsedRow": "Collapsed row",
        "dxDataGrid-ariaExpandedRow": "Expanded row",
        "dxDataGrid-ariaDataGrid": "Tablo",
        "dxDataGrid-ariaSearchInGrid": "Tabloda ara",
        "dxDataGrid-ariaSelectAll": "Hepsini seç",
        "dxDataGrid-ariaSelectRow": "Satırı seç",
        "dxDataGrid-ariaToolbar": "Data grid toolbar",
        "dxDataGrid-ariaEditForm": "Edit form",
        "dxDataGrid-filterBuilderPopupTitle": "Filtre Oluşturucu",
        "dxDataGrid-filterPanelCreateFilter": "Filtre Oluştur",
        "dxDataGrid-filterPanelClearFilter": "Temizle",
        "dxDataGrid-filterPanelFilterEnabledHint": "Filtreyi etkinleştir",

        "dxTreeList-ariaTreeList": "Tree list with {0} rows and {1} columns",
        "dxTreeList-ariaSearchInGrid": "Search in the tree list",
        "dxTreeList-ariaToolbar": "Tree list toolbar",
        "dxTreeList-editingAddRowToNode": "Ekle",

        "dxPager-infoText": "Sayfa {0} / {1} ({2} veri)",
        "dxPager-pagesCountText": "arasında",
        "dxPager-pageSize": "Items per page: {0}",
        "dxPager-pageSizesAllText": "Tümü",
        "dxPager-page": "Page {0}",
        "dxPager-prevPage": "Previous Page",
        "dxPager-nextPage": "Next Page",
        "dxPager-ariaLabel": "Page Navigation",
        "dxPager-ariaPageSize": "Page size",
        "dxPager-ariaPageNumber": "Page number",

        "dxPivotGrid-grandTotal": "Genel Toplam",
        "dxPivotGrid-total": "{0} Toplam",
        "dxPivotGrid-fieldChooserTitle": "Alan Seçici",
        "dxPivotGrid-showFieldChooser": "Alan Seçiciyi Göster",
        "dxPivotGrid-expandAll": "Tümünü Genişlet",
        "dxPivotGrid-collapseAll": "Tümünü Daralt",
        "dxPivotGrid-sortColumnBySummary": "\"{0}\" Bu Sütuna Göre Sırala",
        "dxPivotGrid-sortRowBySummary": "\"{0}\" Bu Satıra Göre Sırala",
        "dxPivotGrid-removeAllSorting": "Tüm Sıralamaları Kaldır",
        "dxPivotGrid-dataNotAvailable": "N/A",
        "dxPivotGrid-rowFields": "Satır Alanları",
        "dxPivotGrid-columnFields": "Sütun Alanları",
        "dxPivotGrid-dataFields": "Veri Alanları",
        "dxPivotGrid-filterFields": "Filtre Alanları",
        "dxPivotGrid-allFields": "Tüm Alanlar",
        "dxPivotGrid-columnFieldArea": "Sütun Alanlarını Buraya Bırak",
        "dxPivotGrid-dataFieldArea": "Veri Alanlarını Buraya Bırak",
        "dxPivotGrid-rowFieldArea": "Satır Alanlarını Buraya Bırak",
        "dxPivotGrid-filterFieldArea": "Filtre Alanlarını Buraya Bırak",

        "dxScheduler-editorLabelTitle": "Konu",
        "dxScheduler-editorLabelStartDate": "Başlangıç Tarihi",
        "dxScheduler-editorLabelEndDate": "Bitiş Tarihi",
        "dxScheduler-editorLabelDescription": "Açıklama",
        "dxScheduler-editorLabelRecurrence": "Tekrar",

        "dxScheduler-openAppointment": "Randevu Aç",

        "dxScheduler-recurrenceNever": "Asla",
        "dxScheduler-recurrenceMinutely": "Minutely",
        "dxScheduler-recurrenceHourly": "Hourly",
        "dxScheduler-recurrenceDaily": "Günlük",
        "dxScheduler-recurrenceWeekly": "Haftalık",
        "dxScheduler-recurrenceMonthly": "Aylık",
        "dxScheduler-recurrenceYearly": "Yıllık",

        "dxScheduler-recurrenceRepeatEvery": "Her tekrarla",
        "dxScheduler-recurrenceRepeatOn": "Tekrarla",
        "dxScheduler-recurrenceEnd": "Tekrarı bitir",
        "dxScheduler-recurrenceAfter": "Sonra",
        "dxScheduler-recurrenceOn": "İle",

        "dxScheduler-recurrenceRepeatMinutely": "minute(s)",
        "dxScheduler-recurrenceRepeatHourly": "hour(s)",
        "dxScheduler-recurrenceRepeatDaily": "günler",
        "dxScheduler-recurrenceRepeatWeekly": "haftalar",
        "dxScheduler-recurrenceRepeatMonthly": "aylar",
        "dxScheduler-recurrenceRepeatYearly": "yıllar",

        "dxScheduler-switcherDay": "Gün",
        "dxScheduler-switcherWeek": "Hafta",
        "dxScheduler-switcherWorkWeek": "Çalışma Haftası",
        "dxScheduler-switcherMonth": "Ay",

        "dxScheduler-switcherAgenda": "Ajanda",

        "dxScheduler-switcherTimelineDay": "Zaman Çizelgesi Günü",
        "dxScheduler-switcherTimelineWeek": "Zaman Çizelgesi Haftası",
        "dxScheduler-switcherTimelineWorkWeek": "Zaman Çizelgesi Çalışma Haftası",
        "dxScheduler-switcherTimelineMonth": "TZaman Çizelgesi Çalışma Ayı",

        "dxScheduler-recurrenceRepeatOnDate": "tarihinde",
        "dxScheduler-recurrenceRepeatCount": "olaylar",
        "dxScheduler-allDay": "Tüm gün",

        "dxScheduler-confirmRecurrenceEditTitle": "Edit Recurring Appointment",
        "dxScheduler-confirmRecurrenceDeleteTitle": "Delete Recurring Appointment",

        "dxScheduler-confirmRecurrenceEditMessage": "Yalnızca bu randevuyu veya tüm diziyi düzenlemek ister misiniz?",
        "dxScheduler-confirmRecurrenceDeleteMessage": "Yalnızca bu randevuyu veya tüm diziyi silmek istiyor musunuz?",

        "dxScheduler-confirmRecurrenceEditSeries": "Serileri düzenle",
        "dxScheduler-confirmRecurrenceDeleteSeries": "Serileri sil",
        "dxScheduler-confirmRecurrenceEditOccurrence": "Randevuyu düzenle",
        "dxScheduler-confirmRecurrenceDeleteOccurrence": "Randevuyu sil",

        "dxScheduler-noTimezoneTitle": "Saat dilimi yok",
        "dxScheduler-moreAppointments": "{0} daha",

        "dxCalendar-todayButtonText": "Bugün",
        "dxCalendar-ariaWidgetName": "Takvim",
        "dxCalendar-previousMonthButtonLabel": "Previous month",
        "dxCalendar-previousYearButtonLabel": "Previous year",
        "dxCalendar-previousDecadeButtonLabel": "Previous decade",
        "dxCalendar-previousCenturyButtonLabel": "Previous century",
        "dxCalendar-nextMonthButtonLabel": "Next month",
        "dxCalendar-nextYearButtonLabel": "Next year",
        "dxCalendar-nextDecadeButtonLabel": "Next decade",
        "dxCalendar-nextCenturyButtonLabel": "Next century",
        "dxCalendar-captionMonthLabel": "Month selection",
        "dxCalendar-captionYearLabel": "Year selection",
        "dxCalendar-captionDecadeLabel": "Decade selection",
        "dxCalendar-captionCenturyLabel": "Century selection",

        "dxColorView-ariaRed": "Kırmızı",
        "dxColorView-ariaGreen": "Yeşil",
        "dxColorView-ariaBlue": "Mavi",
        "dxColorView-ariaAlpha": "Şeffaflık",
        "dxColorView-ariaHex": "Renk kodu",

        "dxTagBox-selected": "{0} seçili",
        "dxTagBox-allSelected": "Tümü seçildi ({0})",
        "dxTagBox-moreSelected": "{0} daha",

        "vizExport-printingButtonText": "Yazdır",
        "vizExport-titleMenuText": "Dışa Aktar/Yazdır",
        "vizExport-exportButtonText": "{0} dosya",

        "dxFilterBuilder-and": "Ve",
        "dxFilterBuilder-or": "Veya",
        "dxFilterBuilder-notAnd": "Değil Ve",
        "dxFilterBuilder-notOr": "Değil Veya",
        "dxFilterBuilder-addCondition": "Koşul Ekle",
        "dxFilterBuilder-addGroup": "Grup Ekle",
        "dxFilterBuilder-enterValueText": "<değer gir>",
        "dxFilterBuilder-filterOperationEquals": "Eşit",
        "dxFilterBuilder-filterOperationNotEquals": "Eşit değil",
        "dxFilterBuilder-filterOperationLess": "Daha küçük",
        "dxFilterBuilder-filterOperationLessOrEquals": "Daha küçük veya eşit",
        "dxFilterBuilder-filterOperationGreater": "Daha büyük",
        "dxFilterBuilder-filterOperationGreaterOrEquals": "Daha büyük veya eşit",
        "dxFilterBuilder-filterOperationStartsWith": "İle başlar",
        "dxFilterBuilder-filterOperationContains": "İçerir",
        "dxFilterBuilder-filterOperationNotContains": "İçermez",
        "dxFilterBuilder-filterOperationEndsWith": "İle biter",
        "dxFilterBuilder-filterOperationIsBlank": "Boş",
        "dxFilterBuilder-filterOperationIsNotBlank": "Boş değil",
        "dxFilterBuilder-filterOperationBetween": "Arasında",
        "dxFilterBuilder-filterOperationAnyOf": "Herhangi biri",
        "dxFilterBuilder-filterOperationNoneOf": "Hiçbiri",

        "dxHtmlEditor-dialogColorCaption": "Yazı Tipi Rengini Değiştir",
        "dxHtmlEditor-dialogBackgroundCaption": "Arka Plan Rengini Değiştir",
        "dxHtmlEditor-dialogLinkCaption": "Link Ekle",
        "dxHtmlEditor-dialogLinkUrlField": "URL",
        "dxHtmlEditor-dialogLinkTextField": "Metin",
        "dxHtmlEditor-dialogLinkTargetField": "Linki yeni pencerede aç",
        "dxHtmlEditor-dialogImageCaption": "Resim Ekle",
        "dxHtmlEditor-dialogImageUrlField": "URL",
        "dxHtmlEditor-dialogImageAltField": "Alternatif metin",
        "dxHtmlEditor-dialogImageWidthField": "Genişlik (px)",
        "dxHtmlEditor-dialogImageHeightField": "Yükseklik (px)",
        "dxHtmlEditor-dialogInsertTableRowsField": "Satır",
        "dxHtmlEditor-dialogInsertTableColumnsField": "Sütun",
        "dxHtmlEditor-dialogInsertTableCaption": "Tablo Ekle",
        "dxHtmlEditor-dialogUpdateImageCaption": "Update Image",
        "dxHtmlEditor-dialogImageUpdateButton": "Update",
        "dxHtmlEditor-dialogImageAddButton": "Add",
        "dxHtmlEditor-dialogImageSpecifyUrl": "From the Web",
        "dxHtmlEditor-dialogImageSelectFile": "From This Device",
        "dxHtmlEditor-dialogImageKeepAspectRatio": "Keep Aspect Ratio",
        "dxHtmlEditor-dialogImageEncodeToBase64": "Encode to Base64",
        "dxHtmlEditor-heading": "Başlık",
        "dxHtmlEditor-normalText": "Normal metin",
        "dxHtmlEditor-background": "Arka Plan Rengi",
        "dxHtmlEditor-bold": "Kalın",
        "dxHtmlEditor-color": "Yazı Tipi Rengi",
        "dxHtmlEditor-font": "Yazı Tipi",
        "dxHtmlEditor-italic": "Yatık",
        "dxHtmlEditor-link": "Bağlantı Ekle",
        "dxHtmlEditor-image": "Resim Ekle",
        "dxHtmlEditor-size": "Boyut",
        "dxHtmlEditor-strike": "Üstü Çizili",
        "dxHtmlEditor-subscript": "Alt Simge",
        "dxHtmlEditor-superscript": "Üst Simge",
        "dxHtmlEditor-underline": "Atı Çizili",
        "dxHtmlEditor-blockquote": "Öbek",
        "dxHtmlEditor-header": "Üst Bilgi",
        "dxHtmlEditor-increaseIndent": "Girintiyi Artır",
        "dxHtmlEditor-decreaseIndent": "Girintiyi Azalt",
        "dxHtmlEditor-orderedList": "Sıralı Liste",
        "dxHtmlEditor-bulletList": "Bullet List",
        "dxHtmlEditor-alignLeft": "Align Left",
        "dxHtmlEditor-alignCenter": "Align Center",
        "dxHtmlEditor-alignRight": "Align Right",
        "dxHtmlEditor-alignJustify": "Align Justify",
        "dxHtmlEditor-codeBlock": "Code Block",
        "dxHtmlEditor-variable": "Add Variable",
        "dxHtmlEditor-undo": "Undo",
        "dxHtmlEditor-redo": "Redo",
        "dxHtmlEditor-clear": "Clear Formatting",
        "dxHtmlEditor-insertTable": "Insert Table",
        "dxHtmlEditor-insertHeaderRow": "Insert Header Row",
        "dxHtmlEditor-insertRowAbove": "Insert Row Above",
        "dxHtmlEditor-insertRowBelow": "Insert Row Below",
        "dxHtmlEditor-insertColumnLeft": "Insert Column Left",
        "dxHtmlEditor-insertColumnRight": "Insert Column Right",
        "dxHtmlEditor-deleteColumn": "Delete Column",
        "dxHtmlEditor-deleteRow": "Delete Row",
        "dxHtmlEditor-deleteTable": "Delete Table",
        "dxHtmlEditor-cellProperties": "Cell Properties",
        "dxHtmlEditor-tableProperties": "Table Properties",
        "dxHtmlEditor-insert": "Insert",
        "dxHtmlEditor-delete": "Delete",
        "dxHtmlEditor-border": "Border",
        "dxHtmlEditor-style": "Style",
        "dxHtmlEditor-width": "Width",
        "dxHtmlEditor-height": "Height",
        "dxHtmlEditor-borderColor": "Color",
        "dxHtmlEditor-tableBackground": "Background",
        "dxHtmlEditor-dimensions": "Dimensions",
        "dxHtmlEditor-alignment": "Alignment",
        "dxHtmlEditor-horizontal": "Horizontal",
        "dxHtmlEditor-vertical": "Vertical",
        "dxHtmlEditor-paddingVertical": "Vertical Padding",
        "dxHtmlEditor-paddingHorizontal": "Horizontal Padding",
        "dxHtmlEditor-pixels": "Pixels",
        "dxHtmlEditor-list": "List",
        "dxHtmlEditor-ordered": "Ordered",
        "dxHtmlEditor-bullet": "Bullet",
        "dxHtmlEditor-align": "Align",
        "dxHtmlEditor-center": "Center",
        "dxHtmlEditor-left": "Left",
        "dxHtmlEditor-right": "Right",
        "dxHtmlEditor-indent": "Indent",
        "dxHtmlEditor-justify": "Justify",
        "dxHtmlEditor-borderStyleNone": "none",
        "dxHtmlEditor-borderStyleHidden": "hidden",
        "dxHtmlEditor-borderStyleDotted": "dotted",
        "dxHtmlEditor-borderStyleDashed": "dashed",
        "dxHtmlEditor-borderStyleSolid": "solid",
        "dxHtmlEditor-borderStyleDouble": "double",
        "dxHtmlEditor-borderStyleGroove": "groove",
        "dxHtmlEditor-borderStyleRidge": "ridge",
        "dxHtmlEditor-borderStyleInset": "inset",
        "dxHtmlEditor-borderStyleOutset": "outset",

        "dxFileManager-newDirectoryName": "Untitled directory",
        "dxFileManager-rootDirectoryName": "Files",
        "dxFileManager-errorNoAccess": "Erişim reddedildi. İşlem tamamlanamıyor.",
        "dxFileManager-errorDirectoryExistsFormat": "Klasör '{0}' zaten var.",
        "dxFileManager-errorFileExistsFormat": "Dosya '{0}' zaten var.",
        "dxFileManager-errorFileNotFoundFormat": "Dosya '{0}' bulunamadı",
        "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
        "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
        "dxFileManager-errorMaxFileSizeExceeded": "File size exceeds the maximum allowed size.",
        "dxFileManager-errorInvalidSymbols": "This name contains invalid characters.",
        "dxFileManager-errorDefault": "Belirtilmemiş hata.",
        "dxFileManager-errorDirectoryOpenFailed": "The directory cannot be opened",

        "dxFileManager-commandCreate": "New directory",
        "dxFileManager-commandRename": "Rename",
        "dxFileManager-commandMove": "Move to",
        "dxFileManager-commandCopy": "Copy to",
        "dxFileManager-commandDelete": "Delete",
        "dxFileManager-commandDownload": "Download",
        "dxFileManager-commandUpload": "Upload files",
        "dxFileManager-commandRefresh": "Refresh",
        "dxFileManager-commandThumbnails": "Thumbnails View",
        "dxFileManager-commandDetails": "Details View",
        "dxFileManager-commandClearSelection": "Clear selection",
        "dxFileManager-commandShowNavPane": "Toggle navigation pane",

        "dxFileManager-dialogDirectoryChooserMoveTitle": "Move to",
        "dxFileManager-dialogDirectoryChooserMoveButtonText": "Move",
        "dxFileManager-dialogDirectoryChooserCopyTitle": "Copy to",
        "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copy",
        "dxFileManager-dialogRenameItemTitle": "Rename",
        "dxFileManager-dialogRenameItemButtonText": "Save",
        "dxFileManager-dialogCreateDirectoryTitle": "New directory",
        "dxFileManager-dialogCreateDirectoryButtonText": "Create",
        "dxFileManager-dialogDeleteItemTitle": "Delete",
        "dxFileManager-dialogDeleteItemButtonText": "Delete",
        "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Are you sure you want to delete {0}?",
        "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Are you sure you want to delete {0} items?",
        "dxFileManager-dialogButtonCancel": "Cancel",

        "dxFileManager-editingCreateSingleItemProcessingMessage": "Creating a directory inside {0}",
        "dxFileManager-editingCreateSingleItemSuccessMessage": "Created a directory inside {0}",
        "dxFileManager-editingCreateSingleItemErrorMessage": "Directory was not created",
        "dxFileManager-editingCreateCommonErrorMessage": "Directory was not created",

        "dxFileManager-editingRenameSingleItemProcessingMessage": "Renaming an item inside {0}",
        "dxFileManager-editingRenameSingleItemSuccessMessage": "Renamed an item inside {0}",
        "dxFileManager-editingRenameSingleItemErrorMessage": "Item was not renamed",
        "dxFileManager-editingRenameCommonErrorMessage": "Item was not renamed",

        "dxFileManager-editingDeleteSingleItemProcessingMessage": "Deleting an item from {0}",
        "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Deleting {0} items from {1}",
        "dxFileManager-editingDeleteSingleItemSuccessMessage": "Deleted an item from {0}",
        "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Deleted {0} items from {1}",
        "dxFileManager-editingDeleteSingleItemErrorMessage": "Item was not deleted",
        "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} items were not deleted",
        "dxFileManager-editingDeleteCommonErrorMessage": "Some items were not deleted",

        "dxFileManager-editingMoveSingleItemProcessingMessage": "Moving an item to {0}",
        "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} items to {1}",
        "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
        "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Moved {0} items to {1}",
        "dxFileManager-editingMoveSingleItemErrorMessage": "Item was not moved",
        "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} items were not moved",
        "dxFileManager-editingMoveCommonErrorMessage": "Some items were not moved",

        "dxFileManager-editingCopySingleItemProcessingMessage": "Copying an item to {0}",
        "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copying {0} items to {1}",
        "dxFileManager-editingCopySingleItemSuccessMessage": "Copied an item to {0}",
        "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copied {0} items to {1}",
        "dxFileManager-editingCopySingleItemErrorMessage": "Item was not copied",
        "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} items were not copied",
        "dxFileManager-editingCopyCommonErrorMessage": "Some items were not copied",

        "dxFileManager-editingUploadSingleItemProcessingMessage": "Uploading an item to {0}",
        "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Uploading {0} items to {1}",
        "dxFileManager-editingUploadSingleItemSuccessMessage": "Uploaded an item to {0}",
        "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Uploaded {0} items to {1}",
        "dxFileManager-editingUploadSingleItemErrorMessage": "Item was not uploaded",
        "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} items were not uploaded",
        "dxFileManager-editingUploadCanceledMessage": "Canceled",

        "dxFileManager-editingDownloadSingleItemErrorMessage": "Item was not downloaded",
        "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} items were not downloaded",

        "dxFileManager-listDetailsColumnCaptionName": "Name",
        "dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
        "dxFileManager-listDetailsColumnCaptionFileSize": "File Size",

        "dxFileManager-listThumbnailsTooltipTextSize": "Size",
        "dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",

        "dxFileManager-notificationProgressPanelTitle": "Progress",
        "dxFileManager-notificationProgressPanelEmptyListText": "No operations",
        "dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",

        "dxDiagram-categoryGeneral": "General",
        "dxDiagram-categoryFlowchart": "Flowchart",
        "dxDiagram-categoryOrgChart": "Org Chart",
        "dxDiagram-categoryContainers": "Containers",
        "dxDiagram-categoryCustom": "Custom",

        "dxDiagram-commandExportToSvg": "Export to SVG",
        "dxDiagram-commandExportToPng": "Export to PNG",
        "dxDiagram-commandExportToJpg": "Export to JPEG",
        "dxDiagram-commandUndo": "Undo",
        "dxDiagram-commandRedo": "Redo",
        "dxDiagram-commandFontName": "Font Name",
        "dxDiagram-commandFontSize": "Font Size",
        "dxDiagram-commandBold": "Bold",
        "dxDiagram-commandItalic": "Italic",
        "dxDiagram-commandUnderline": "Underline",
        "dxDiagram-commandTextColor": "Font Color",
        "dxDiagram-commandLineColor": "Line Color",
        "dxDiagram-commandLineWidth": "Line Width",
        "dxDiagram-commandLineStyle": "Line Style",
        "dxDiagram-commandLineStyleSolid": "Solid",
        "dxDiagram-commandLineStyleDotted": "Dotted",
        "dxDiagram-commandLineStyleDashed": "Dashed",
        "dxDiagram-commandFillColor": "Fill Color",
        "dxDiagram-commandAlignLeft": "Align Left",
        "dxDiagram-commandAlignCenter": "Align Center",
        "dxDiagram-commandAlignRight": "Align Right",
        "dxDiagram-commandConnectorLineType": "Connector Line Type",
        "dxDiagram-commandConnectorLineStraight": "Straight",
        "dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
        "dxDiagram-commandConnectorLineStart": "Connector Line Start",
        "dxDiagram-commandConnectorLineEnd": "Connector Line End",
        "dxDiagram-commandConnectorLineNone": "None",
        "dxDiagram-commandConnectorLineArrow": "Arrow",
        "dxDiagram-commandFullscreen": "Full Screen",
        "dxDiagram-commandUnits": "Units",
        "dxDiagram-commandPageSize": "Page Size",
        "dxDiagram-commandPageOrientation": "Page Orientation",
        "dxDiagram-commandPageOrientationLandscape": "Landscape",
        "dxDiagram-commandPageOrientationPortrait": "Portrait",
        "dxDiagram-commandPageColor": "Page Color",
        "dxDiagram-commandShowGrid": "Show Grid",
        "dxDiagram-commandSnapToGrid": "Snap to Grid",
        "dxDiagram-commandGridSize": "Grid Size",
        "dxDiagram-commandZoomLevel": "Zoom Level",
        "dxDiagram-commandAutoZoom": "Auto Zoom",
        "dxDiagram-commandFitToContent": "Fit to Content",
        "dxDiagram-commandFitToWidth": "Fit to Width",
        "dxDiagram-commandAutoZoomByContent": "Auto Zoom by Content",
        "dxDiagram-commandAutoZoomByWidth": "Auto Zoom by Width",
        "dxDiagram-commandSimpleView": "Simple View",
        "dxDiagram-commandCut": "Cut",
        "dxDiagram-commandCopy": "Copy",
        "dxDiagram-commandPaste": "Paste",
        "dxDiagram-commandSelectAll": "Select All",
        "dxDiagram-commandDelete": "Delete",
        "dxDiagram-commandBringToFront": "Bring to Front",
        "dxDiagram-commandSendToBack": "Send to Back",
        "dxDiagram-commandLock": "Lock",
        "dxDiagram-commandUnlock": "Unlock",
        "dxDiagram-commandInsertShapeImage": "Insert Image...",
        "dxDiagram-commandEditShapeImage": "Change Image...",
        "dxDiagram-commandDeleteShapeImage": "Delete Image",
        "dxDiagram-commandLayoutLeftToRight": "Left-to-right",
        "dxDiagram-commandLayoutRightToLeft": "Right-to-left",
        "dxDiagram-commandLayoutTopToBottom": "Top-to-bottom",
        "dxDiagram-commandLayoutBottomToTop": "Bottom-to-top",

        "dxDiagram-unitIn": "in",
        "dxDiagram-unitCm": "cm",
        "dxDiagram-unitPx": "px",

        "dxDiagram-dialogButtonOK": "OK",
        "dxDiagram-dialogButtonCancel": "Cancel",
        "dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
        "dxDiagram-dialogEditShapeImageTitle": "Change Image",
        "dxDiagram-dialogEditShapeImageSelectButton": "Select image",
        "dxDiagram-dialogEditShapeImageLabelText": "or drop a file here",

        "dxDiagram-uiExport": "Export",
        "dxDiagram-uiProperties": "Properties",
        "dxDiagram-uiSettings": "Settings",
        "dxDiagram-uiShowToolbox": "Show Toolbox",
        "dxDiagram-uiSearch": "Search",
        "dxDiagram-uiStyle": "Style",
        "dxDiagram-uiLayout": "Layout",
        "dxDiagram-uiLayoutTree": "Tree",
        "dxDiagram-uiLayoutLayered": "Layered",
        "dxDiagram-uiDiagram": "Diagram",
        "dxDiagram-uiText": "Text",
        "dxDiagram-uiObject": "Object",
        "dxDiagram-uiConnector": "Connector",
        "dxDiagram-uiPage": "Page",

        "dxDiagram-shapeText": "Text",
        "dxDiagram-shapeRectangle": "Rectangle",
        "dxDiagram-shapeEllipse": "Ellipse",
        "dxDiagram-shapeCross": "Cross",
        "dxDiagram-shapeTriangle": "Triangle",
        "dxDiagram-shapeDiamond": "Diamond",
        "dxDiagram-shapeHeart": "Heart",
        "dxDiagram-shapePentagon": "Pentagon",
        "dxDiagram-shapeHexagon": "Hexagon",
        "dxDiagram-shapeOctagon": "Octagon",
        "dxDiagram-shapeStar": "Star",
        "dxDiagram-shapeArrowLeft": "Left Arrow",
        "dxDiagram-shapeArrowUp": "Up Arrow",
        "dxDiagram-shapeArrowRight": "Right Arrow",
        "dxDiagram-shapeArrowDown": "Down Arrow",
        "dxDiagram-shapeArrowUpDown": "Up Down Arrow",
        "dxDiagram-shapeArrowLeftRight": "Left Right Arrow",
        "dxDiagram-shapeProcess": "Process",
        "dxDiagram-shapeDecision": "Decision",
        "dxDiagram-shapeTerminator": "Terminator",
        "dxDiagram-shapePredefinedProcess": "Predefined Process",
        "dxDiagram-shapeDocument": "Document",
        "dxDiagram-shapeMultipleDocuments": "Multiple Documents",
        "dxDiagram-shapeManualInput": "Manual Input",
        "dxDiagram-shapePreparation": "Preparation",
        "dxDiagram-shapeData": "Data",
        "dxDiagram-shapeDatabase": "Database",
        "dxDiagram-shapeHardDisk": "Hard Disk",
        "dxDiagram-shapeInternalStorage": "Internal Storage",
        "dxDiagram-shapePaperTape": "Paper Tape",
        "dxDiagram-shapeManualOperation": "Manual Operation",
        "dxDiagram-shapeDelay": "Delay",
        "dxDiagram-shapeStoredData": "Stored Data",
        "dxDiagram-shapeDisplay": "Display",
        "dxDiagram-shapeMerge": "Merge",
        "dxDiagram-shapeConnector": "Connector",
        "dxDiagram-shapeOr": "Or",
        "dxDiagram-shapeSummingJunction": "Summing Junction",
        "dxDiagram-shapeContainerDefaultText": "Container",
        "dxDiagram-shapeVerticalContainer": "Vertical Container",
        "dxDiagram-shapeHorizontalContainer": "Horizontal Container",
        "dxDiagram-shapeCardDefaultText": "Person's Name",
        "dxDiagram-shapeCardWithImageOnLeft": "Card with Image on the Left",
        "dxDiagram-shapeCardWithImageOnTop": "Card with Image on the Top",
        "dxDiagram-shapeCardWithImageOnRight": "Card with Image on the Right",

        "dxGantt-dialogTitle": "Title",
        "dxGantt-dialogStartTitle": "Start",
        "dxGantt-dialogEndTitle": "End",
        "dxGantt-dialogProgressTitle": "Progress",
        "dxGantt-dialogResourcesTitle": "Resources",
        "dxGantt-dialogResourceManagerTitle": "Resource Manager",
        "dxGantt-dialogTaskDetailsTitle": "Task Details",
        "dxGantt-dialogEditResourceListHint": "Edit Resource List",
        "dxGantt-dialogEditNoResources": "No resources",
        "dxGantt-dialogButtonAdd": "Add",
        "dxGantt-contextMenuNewTask": "New Task",
        "dxGantt-contextMenuNewSubtask": "New Subtask",
        "dxGantt-contextMenuDeleteTask": "Delete Task",
        "dxGantt-contextMenuDeleteDependency": "Delete Dependency",
        "dxGantt-dialogTaskDeleteConfirmation": "Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?",
        "dxGantt-dialogDependencyDeleteConfirmation": "Are you sure you want to delete the dependency from the task?",
        "dxGantt-dialogResourcesDeleteConfirmation": "Deleting a resource also deletes it from tasks to which this resource is assigned. Are you sure you want to delete these resources? Resources: {0}",
        "dxGantt-dialogConstraintCriticalViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. This change would conflict with dependency rules. How would you like to proceed?",
        "dxGantt-dialogConstraintViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. How would you like to proceed?",
        "dxGantt-dialogCancelOperationMessage": "Cancel the operation",
        "dxGantt-dialogDeleteDependencyMessage": "Delete the dependency",
        "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Move the task and keep the dependency",
        "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. This change would conflict with dependency rules. How would you like to proceed?",
        "dxGantt-dialogConstraintViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. How would you like to proceed?",
        "dxGantt-dialogDeleteDependenciesMessage": "Delete the dependency relations",
        "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Move the task and keep the dependencies",
        "dxGantt-undo": "Undo",
        "dxGantt-redo": "Redo",
        "dxGantt-expandAll": "Expand All",
        "dxGantt-collapseAll": "Collapse All",
        "dxGantt-addNewTask": "Add New Task",
        "dxGantt-deleteSelectedTask": "Delete Selected Task",
        "dxGantt-zoomIn": "Zoom In",
        "dxGantt-zoomOut": "Zoom Out",
        "dxGantt-fullScreen": "Full Screen",
        "dxGantt-quarter": "Q{0}",
        "dxGantt-sortingAscendingText": "Artan Sıralama",
        "dxGantt-sortingDescendingText": "Azalan Sıralama",
        "dxGantt-sortingClearText": "Sıralamayı Temizle",
        "dxGantt-showResources": "Show Resources",
        "dxGantt-showDependencies": "Show Dependencies",
        "dxGantt-dialogStartDateValidation": "Start date must be after {0}",
        "dxGantt-dialogEndDateValidation": "End date must be after {0}",

        "dxGallery-itemName": "Gallery item",

        "dxMultiView-elementAriaRoleDescription": "MultiView",
        "dxMultiView-elementAriaLabel": "Use the arrow keys or swipe to navigate between views",
        "dxMultiView-itemAriaRoleDescription": "View",
        "dxMultiView-itemAriaLabel": "{0} of {1}"
    }
}
